import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';
import { ArrowBackIos } from '@material-ui/icons';
import { Field, reduxForm } from "redux-form";
import { hideProgressBar } from '../../utils/handleProgress'
import { clubbedOtpData, firstScreenQuestionResp } from '../../utils/staticQuestionDataForNewScreen';
import createInput from '../../utils/createInputs';
import ImpactedPolicyModal from './ImpactedPolicyModal/ImpactedPolicyModal';
import { getApiData } from '../../api/api';
import AxiosRequest from '../../utils/axios';
import './PolicySpecficQuestions.css';
import DotsLoader from '../Loader/DotsLoader/DotsLoader';
import ActionSheetModal from './ActionSheetModal/ActionSheetModal';
import { Button } from 'unified-ui-components-library'

const axios = new AxiosRequest().getClient();

const PolicySpecficQuestions = () => {
    const router = useHistory()

    const [questions, setQuestions] = useState(null)
    const [policyListWithQuestions, setPolicyListWithQuestions] = useState(null)
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(null)
    const [policyData, setPolicyData] = useState(null)
    const [showImpactedPolicyModal, setShowImpactedPolicyModal] = useState(false)
    const [policyCount, setPolicyCount] = useState(0)
    const [loading, setLoading] = useState(true)
    const [getQuestionsError, setGetQuestionsError] = useState(false)
    const [showActionSheet, setShowActionSheet] = useState(false)
    const [category, setCategory] = useState("")
    const [modalData, setModalData] = useState({
        modalType: "",
        heading: "",
        description: "",
        modalBtns: []
    })
    useEffect(() => {
        getQuestions()
        hideProgressBar()
        // setQuestions(firstScreenQuestionResp.response.payload.customerResponse[0].qst)
        let allData = [];
        const data = JSON.parse(localStorage.getItem("allinsurerDetails"))
        data.forEach((d, index) => {
            d.isExpanded = false
            d.id = index
            allData.push(d);
        });
        setPolicyData(allData)
    }, [])

    useEffect(() => {
        let impactedPolicyCount = 0
        if(policyData && policyData.length) {
            const policiesMap = policyListWithQuestions[questions[currentQuestionIndex]?.qstId]
            policyData.forEach((policy) => {
                if (policiesMap?.includes(policy?.policyNumber)) {
                    impactedPolicyCount++
                }
            })
        }
        setPolicyCount(impactedPolicyCount)
    }, [currentQuestionIndex])

    const getQuestions = async () => {
        setLoading(true)
        const { url, body } = getApiData("getQuestions");
        body.request.payload.lang = localStorage.getItem("LanguageSelected");
        body.request.payload.qstCatName = localStorage.getItem("category");;
        body.request.payload.posvRefNumbers = getRefNumbersList();
        try {
            const response = await axios.post(url, body);
            if (response?.status === 200) {
                if (response?.data?.response?.payload?.customerResponse) {
                    if (response.data?.response?.payload?.customerResponse[0]?.qst?.length > 0) {
                        setQuestions(response.data.response.payload.customerResponse[0].qst)
                        setCategory(response.data.response.payload.qstCatName)
                        setPolicyListWithQuestions(response.data.response.payload.policyQuestions)
                        setCurrentQuestionIndex(0)
                        sessionStorage.setItem('policyQuesMap', JSON.stringify(response.data.response.payload.policyQuestions))
                    } else {
                        router.push('/generate_otp')
                    }
                } else {
                    router.push('/generate_otp')
                }
            } else {
                setGetQuestionsError(true)
            }

        } catch (error) {
            console.log('Policy question err :: ', error)
            setGetQuestionsError(true)
        } finally {
            setLoading(false)
        }
    }

    const getRefNumbersList = () => {
        const policyList = JSON.parse(localStorage.getItem("allinsurerDetails"))
        const refNumberList = policyList.map((policy) => policy.posvRefNumber)
        return refNumberList
    }

    const onUserAnswer = (event, ques) => {
        const { value } = event.target
        const allQuestions = JSON.parse(JSON.stringify(questions))
        const question = allQuestions.filter((q) => q.qstId === ques.qstId);
        question[0].customerResponse = value
        setQuestions(allQuestions)
    }

    const handleNext = () => {
        if ((currentQuestionIndex + 1) < questions.length && questions[currentQuestionIndex].customerResponse === "Yes") {
            setCurrentQuestionIndex((prev) => prev + 1)
        } else {
            if (questions[currentQuestionIndex].customerResponse === "No") {
                setModalData({
                    modalType: "error",
                    heading: "Some of your answers seems incorrect!",
                    description: "You can review your response or exit to re-initiate the journey.",
                    modalBtns: [
                        {
                            text: "Exit",
                            cancel: true,
                            action: () => {
                                console.log("Route to blocked journey page")
                                router.push('/blocked_journey?s=pc')
                            }
                        },
                        {
                            text: "Review",
                            cancel: false,
                            action: () => setShowActionSheet(false)
                        }
                    ]
                })
                setShowActionSheet(true)
            } else {
                console.log("SUBMIT Questions")
                submitQuestions()
            }
        }
    }

    const handleBack = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex((prev) => prev - 1)
        }
    }

    const handleAccordionExpansion = (id) => {
        let allData = JSON.parse(JSON.stringify(policyData));
        allData.map((data) => {
            if (data.id === id) {
                data.isExpanded = !data.isExpanded
            } else {
                data.isExpanded = false
            }
            return data
        })
        setPolicyData(allData);
    }

    const submitQuestions = async () => {
        setLoading(true)
        const { url, body } = getApiData("saveCustomerResponse");
        const data = JSON.parse(localStorage.getItem("allinsurerDetails"))
        const allinsurerDetails = data.map((d) => {
            return {
                policyNumber: d.policyNumber,
                posvRefNumber: d.posvRefNumber
            }
        })
        body.request.payload.lang = localStorage.getItem("LanguageSelected");
        body.request.payload.qstCatName = category;
        body.request.payload.customerResponse.qstCatName = category;
        body.request.payload.customerResponse = [{ qst : questions, qstCatName: category }];
        body.request.payload.policyQuestions = policyListWithQuestions;
        body.request.payload.allinsurerDetails = allinsurerDetails;
        console.log("Questions Submitted", body, url)
        try {

            const response = await axios.post(url, body)
            console.log(response)
            if (response.data.response.msgInfo.msgCode === "200") {
                setModalData({
                    modalType: "success",
                    heading: "Policy specific questions resolved successfully!",
                    description: "You can click on proceed to continue for confirming the other policies.",
                    modalBtns: [
                        {
                            text: "Proceed",
                            cancel: false,
                            action: () => {
                                setShowActionSheet(false)
                                router.push('/generate_otp')
                            }
                        }
                    ]
                })
                setShowActionSheet(true)
            } else {
                setModalData({
                    modalType: "error",
                    heading: "Something Went Wrong!",
                    description: "Please try again later.",
                    modalBtns: [
                        {
                            text: "Close",
                            cancel: false,
                            action: () => {
                                setShowActionSheet(false)
                                // router.push('/generate_otp')
                            }
                        }
                    ]
                })
            }
        } catch (error) {
            setModalData({
                modalType: "error",
                heading: "Something Went Wrong!",
                description: "Please try after sometime.",
                modalBtns: [
                    {
                        text: "Close",
                        cancel: false,
                        action: () => {
                            setShowActionSheet(false)
                            // router.push('/generate_otp')
                        }
                    }
                ]
            })
        } finally {
            setLoading(false)
        }
    }

    if (loading) return <DotsLoader msg={"Please wait..."} />

    if (getQuestionsError) return <div className='policy-question-wrapper'>
        <div className='talic-err-msg-cntnr'>
            <p>Something Went wrong!</p>
        </div>
    </div>
    return (
        <div className='policy-question-wrapper'>
            <h4 className="hd-pol">Policy Specific Questions</h4>
            <p className="pagination-btns">
                {currentQuestionIndex > 0 && <ArrowBackIos fontSize='small' className='bck-arw' onClick={handleBack} />}
                <span>{currentQuestionIndex + 1}</span>
                <span className='total-ques'>/{questions ? questions.length : null} questions</span>
            </p>
            <div className='posv-2-ques customerFeedback-container '>
                <div className="cust_feedback--page">
                    <form className="customerFeedback-form">
                        {
                            questions && questions.length > 0 && <Field
                                label="Label"
                                name={questions[currentQuestionIndex].qstId}
                                type={questions[currentQuestionIndex].qstOptType}
                                question={questions[currentQuestionIndex]}
                                component={createInput}
                                handleUserAnswer={onUserAnswer}
                            />
                        }
                    </form>
                </div>
            </div>
            <div className="otherLanguages" onClick={() => setShowImpactedPolicyModal(true)}>
                {/* <p>Show ({`${policyCount}/${policyData.length}`}) Impacted Policies</p> */}
                <Button
                    buttonType='neutralLink'
                >
                    {`Show (${policyCount}/${policyData.length}) Impacted Policies`}
                </Button>
            </div>
            {questions && questions.length > 0 && <div className="clubbed-button-container">
                <Button disabled={!questions[currentQuestionIndex].customerResponse} onClick={handleNext}>Next</Button>
            </div>}
            {showImpactedPolicyModal && <ImpactedPolicyModal policyListWithQuestions={policyListWithQuestions[questions[currentQuestionIndex].qstId]} policyData={policyData} handleAccordionExpansion={handleAccordionExpansion} handleModal={setShowImpactedPolicyModal} />}
            {showActionSheet && <ActionSheetModal
                buttons={modalData.modalBtns}
                modalType={modalData.modalType}
                heading={modalData.heading}
                description={modalData.description}
            />}
        </div>
    )
}

export default reduxForm({ form: "policySpecficQuestionsForm" })(PolicySpecficQuestions)
